// Next.js runs this file once in the browser before the app hydrates
// (instrumentation-client convention, Next 15.3+). It is the only place the RUM
// SDK is initialised; everything else goes through lib/datadog/rum.ts.
import { datadogRum } from '@datadog/browser-rum';
import { nextjsPlugin, onRouterTransitionStart } from '@datadog/browser-rum-nextjs';
import { logger } from '@/lib/logger';
import { rumEnv } from '@/lib/datadog/env';
import { rumInitConfiguration } from '@/lib/datadog/rumConfig';

// The plugin captures each client navigation's URL through this hook before
// React renders, which is what makes the view URL right on route transitions.
export { onRouterTransitionStart };

try {
  const configuration = rumInitConfiguration(rumEnv);
  if (configuration) {
    datadogRum.init({
      ...configuration,
      // Names views by route pattern (`/c/[conversationId]`) and starts a new
      // view per App Router navigation via <DatadogAppRouter /> in Providers.
      plugins: [nextjsPlugin()],
    });
  }
} catch (error) {
  // rumInitConfiguration throws on a half-set or malformed config rather than
  // quietly sending nothing, but that throw must not escape: this runs at module
  // scope during client bootstrap, so letting it propagate would take the whole
  // app down over a mistyped observability variable. The misconfiguration is
  // still loud — an error on every page load, and no data in Datadog — while the
  // product keeps working.
  logger.error('[datadog] RUM not started; check the NEXT_PUBLIC_DATADOG_* variables:', error);
}
